/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"

function SEO({ title }: any) {
  return (
    <>
      <meta name="description" content="Realiza tus depositos mediante Webpay"/>
      <meta property="og:title" content={`Depositos Capitaria Chile | ${title}`}/>
      <meta property="og:description" content="Realiza tus depositos mediante Webpay"/>
      <meta property="og:type" content="`website`"/>
      <meta name="twitter:card" content="`summary`"/>
      <meta name="twitter:creator" content="Capitaria"/>
      <meta name="twitter:title" content={`Depositos Capitaria Chile | ${title}`}/>
      <meta name="twitter:description" content="Realiza tus depositos mediante Webpay"/>
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="" />
      <link href="https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,400;0,500;0,600;1,400;1,500;1,600&family=Roboto:ital,wght@0,400;0,500;0,700;1,400;1,500;1,700&display=swap" rel="stylesheet" />
    </>
  )
}

SEO.defaultProps = {
}

SEO.propTypes = {
  title: PropTypes.string.isRequired,
}

export default SEO
